import { FolkProximity, FolkCluster } from '../folk-proximity';
FolkProximity.define();
export { FolkProximity, FolkCluster };
//# sourceMappingURL=folk-proximity.js.map